import { computeRoutePdfLength } from "utils/computeRoutePdfLength";
import type { ApplyPageCalibrationToPlan } from "./types";

/**
 * Mirrors the backend's calibration recompute in the local plan cache:
 * stores the new `metersPerPdfPoint` for the page and recomputes meters
 * for every route belonging to that page. Group totals are refreshed too.
 */
export const applyPageCalibrationToPlan: ApplyPageCalibrationToPlan = ({
  plan,
  pageIndex,
  metersPerPdfPoint,
  source = "manual",
}) => {
  const updatedScales = new Map(plan.metersPerPdfPointByPageIndex);
  updatedScales.set(pageIndex, metersPerPdfPoint);

  const updatedSources = new Map(plan.metersPerPdfPointSourceByPageIndex);
  updatedSources.set(pageIndex, source);

  const updatedRouteGroups = plan.routeGroups.map((group) => {
    const updatedRoutes = group.routes.map((route) => {
      if (route.page !== pageIndex) return route;
      const polylineLength = computeRoutePdfLength({
        nodes: route.nodes,
        edges: route.edges,
      });
      return {
        ...route,
        meters: metersPerPdfPoint * polylineLength,
      };
    });
    const totalMeters = updatedRoutes.reduce(
      (sum, route) => sum + route.meters,
      0,
    );
    return { ...group, routes: updatedRoutes, meters: totalMeters };
  });

  return {
    ...plan,
    metersPerPdfPointByPageIndex: updatedScales,
    metersPerPdfPointSourceByPageIndex: updatedSources,
    routeGroups: updatedRouteGroups,
  };
};
